import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { Tamanho, TamanhoModel } from "../../models/produto.model";
import { CastModelUtils } from "../../utils/CastModelUtils";
import { ModalController } from "@ionic/angular";
import { PizzaLasanhaGrid } from "src/app/pages/integracao/grid-pizzas-lasanhas/pizza-lasanha-grid.viewmodel";
import { PizzaLasanhaRequest, TamanhoRequest } from "../../interfaces/pizza-lasanha.interface";

@Component({
    selector: "app-cadastro-pizza-lasanha",
    templateUrl: "./cadastro-pizza-lasanha.component.html",
    styleUrls: ["./cadastro-pizza-lasanha.component.scss"]
})
export class CadastroPizzaLasanhaComponent implements OnChanges, OnInit {
    @Input() tamanhos: Tamanho[] = [];

    public tamanhosModel: TamanhoModel[] = [];
    public sabor: string = '';

    constructor(
        private modalCtrl: ModalController
    ) {}

    ngOnInit() {
        this.converterTamanhoParaModel();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['tamanhos']) {
            this.converterTamanhoParaModel();
        }
    }

    private converterTamanhoParaModel() {
        const tamanhos = this.tamanhos.map((t) => CastModelUtils.ClonarObjetoComPropriedadesIguais(t, new TamanhoModel()));
        this.tamanhosModel = tamanhos;
    }

    public adicionarSabor() {
        const tamanhosRequest: TamanhoRequest[] = this.tamanhosModel.map((t) => {
            const result: TamanhoRequest = { tamanho: t.nome, valor: t.valor }
            return result;
        });
        
        const pizzaLasanhaRequest: PizzaLasanhaRequest = {
            sabor: this.sabor,
            tamanhos: tamanhosRequest,
        }

        this.modalCtrl.dismiss(pizzaLasanhaRequest);
    }
    
    public fechar() {
        this.modalCtrl.dismiss();
    }
}